export default "__VITE_ASSET__Cy4Dd__v__"